// removed by extract-text-webpack-plugin
module.exports = {"change-box-left":"_3nfu7e733DnjGzjTS7OVk9_0","change-box-right":"_1h98xdeJgFHygiKY74fsCl_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1301313e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/config/node/components/DbmsChangeHistPopup.vue
// module id = Byf7
// module chunks = 75